import { WEB_COMPONENT_EASM_PERIODIC_ASSETS } from '../../../../webcomponents.constants';
import { EasmPeriodicAssetsPayload } from '@nirvana/shared/dtos/types/widgets/common';
import { html, TemplateResult } from 'lit';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property } from 'lit/decorators.js';
import moment from 'moment-timezone';
import { translateFn } from '../../../../utils/translator.helper';

@customElement(WEB_COMPONENT_EASM_PERIODIC_ASSETS)
export class GzEasmAssetsPerWeekWebComponent extends GzGenericWidgetContent {
  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: EasmPeriodicAssetsPayload;

  public renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  public renderContent(): TemplateResult {
    const categories: string[] = [];
    const data = this.payload?.easmPeriodicAssets;
    const dataForChart: number[] = [];

    if (data) {
      data.forEach(item => {
        const date = moment(item.date).tz('UTC');
        categories.push(date.format('D MMM'));
        dataForChart.push(item.totalAssets);
      });
    }
    const series = [
      {
        name: translateFn('Assets'),
        data: dataForChart,
      },
    ];

    const chartWidth = this.contentWidth;
    const chartHeight = this.contentHeight - 16; // chart bottom should be 16px from the bottom of the widget

    return html`<gz-general-chart
      .series="${series}"
      .categories="${categories}"
      .emptyMessage="${translateFn('No data available')}"
      .displaySumInLegend="${true}"
      .width="${chartWidth}"
      .height="${chartHeight}"
    >
    </gz-general-chart>`;
  }
}
